import { MyBetsEventModel } from '../my-bets/models/my-bets-event.model';
import { ScoreboardViewModel } from './models/scoreboard.viewmodel';

export abstract class ScoreboardComponentBase {
    protected event: MyBetsEventModel;

    vm: ScoreboardViewModel;

    update(event: MyBetsEventModel, scoreboardViewModel: ScoreboardViewModel): void {
        this.event = event;
        this.vm = scoreboardViewModel;
    }
}
